import ExpandMore from '@mui/icons-material/ExpandMore'
import { Collapse, List, ListItemIcon, MenuItem, Tooltip, Typography } from '@mui/material'
import { useAuthProvider } from 'context/auth/AuthProvider'
import { ReactElement, ReactNode } from 'react'

interface SubMenuProps {
    dense: boolean
    handleToggleCallback: () => void
    icon: ReactElement
    isOpen: boolean
    name: string
    children: ReactNode
}

const SubMenu = ({ handleToggleCallback, isOpen, name, icon, children, dense }: SubMenuProps) => {
    const { permissions, isLoading } = useAuthProvider()
    let display = false

    if (isLoading) {
        return <></>
    }

    //If none of the submenu items are available, hide the collapsible
    if (Array.isArray(children) && children?.length) {
        children?.forEach((element: any) => {
            if (permissions?.[element?.props?.name]?.length) {
                display = true
            }
        })
    }

    const header = (
        <MenuItem dense={dense} onClick={handleToggleCallback}>
            <ListItemIcon sx={{ minWidth: '40px !important' }}>
                {isOpen ? <ExpandMore /> : icon}
            </ListItemIcon>
            <Typography variant="inherit" color="textSecondary">
                {name}
            </Typography>
        </MenuItem>
    )

    return display ? (
        <div>
            {isOpen ? (
                header
            ) : (
                <Tooltip title={name} placement="right">
                    {header}
                </Tooltip>
            )}
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <List dense={dense} component="div">
                    {children}
                </List>
            </Collapse>
        </div>
    ) : null
}

export default SubMenu
